<template>
  <div></div>
</template>

<script>
export default {
  name: "sso",
  data() {
    return {};
  },
  mounted() {
    this.login();
  },
  methods: {
    async login() {
      let token = this.$route.query.token;
      // eslint-disable-next-line no-unused-vars
      let that = this;
      // eslint-disable-next-line no-eq-null
      if (token) {
          localStorage.setItem("daping_token", token)
          // sessionStorage.setItem("daping_token", token)
          .then(function() {
            this.$router.push("/")
          })
          .catch(function(err) {
            // 当出错时，此处代码运行
            console.log(err);
          });
      } 
    }
  }
};
</script>

<style scoped>
</style>
